.gift {
  border: 2px dashed #ED1B34;
  border-radius: 5px;
  padding: 10px 15px;
  background: #F2F2F2;
  margin-top: 12px;
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

.thumbs {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.thumb {
  width: 62px;
  height: 62px;
  border-radius: 13px;
  overflow: hidden;
  flex-shrink: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.text {
  flex: 1;
  margin: 0;
  font-size: 18px;
  color: #000;
  line-height: 1.3;
}

.line {
  display: block;
}

.amount {
  font-size: 18px;
  font-weight: 800;
  color: #ED1B34;
}

.chevron {
  flex-shrink: 0;
  color: #ED1B34;
  transition: transform 0.2s ease;
}

.chevronOpen {
  transform: rotate(180deg);
}

.panel {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.itemCopy {
  display: flex;
  flex-direction: column;
}

.itemTitle {
  font-size: 16px;
  font-weight: 700;
  color: #000;
}

.itemPrice {
  font-size: 16px;
  font-weight: 700;
  color: #ED1B34;
  margin-left: 6px;
}

.itemDesc {
  font-size: 14px;
  color: #555;
}
